import gsap from 'gsap'
import React, {useEffect, useRef} from 'react'
import {render} from 'storyblok-rich-text-react-renderer'

import {makeEditable, unwrapAllNodeResolvers} from '@/common/utils'

const KeyFiguresItem = ({leading, number, trailing, increment, content, _editable}) => {
  const sectionRef = useRef()
  const numberRef = useRef()

  useEffect(() => {
    const context = gsap.context(() => {
      gsap.fromTo(
        numberRef.current,
        {innerText: 0},
        {
          scrollTrigger: {
            trigger: sectionRef.current,
          },
          innerText: number,
          duration: 1,
          snap: {
            innerText: increment,
          },
        }
      )
    })

    return () => context.revert()
  }, [number, increment])

  return (
    <li
      {...makeEditable(_editable)}
      className='relative flex flex-col flex-wrap gap-5 p-0'
      ref={sectionRef}
    >
      {(leading || number || trailing) && (
        <span className='heading-s-millik text-purple-900'>
          {leading}
          <span ref={numberRef}>{number}</span>
          {trailing}
        </span>
      )}
      <span className='body-m-regular text-purple-900'>
        {render(content, {nodeResolvers: unwrapAllNodeResolvers})}
      </span>
    </li>
  )
}

export default KeyFiguresItem
